import LicensePlate from './LicensePlate.tsx';

export default LicensePlate;